import { DateAdapter } from '@/data/protocols'
import { MomentDateAdapter } from '@/infra/adapters'

export const makeDateAdapterFactory = (): DateAdapter => {
  return new MomentDateAdapter()
}
